import { Trans as I18nTrans } from 'react-i18next';
import type { TransProps } from 'react-i18next';
import type { TFunction } from 'i18next';
import { useCommonTranslation } from '../utils';

type AppTFunction = ReturnType<typeof useCommonTranslation>['t'];

type BaseTransProps = TransProps<string, string, unknown, undefined>;

type AppTransProps = Omit<BaseTransProps, 't'> & {
  t?: AppTFunction;
};

export const Trans = ({ t, ...props }: AppTransProps) => (
  <I18nTrans {...props} t={t as TFunction} />
);
